import axios from "axios";
import { encryptData, decryptData } from "./encryptionHelper";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const token = sessionStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      if (config.data && !config._isEncrypted) {
        const encryptedPayload = encryptData(config.data);
        if (encryptedPayload.iv || !config.data.iv) {
          config.data = encryptedPayload;
        }
      }
    } catch (error) {
      console.error("Request encryption error:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Decrypt response payload
axiosInstance.interceptors.response.use(
  (response) => {
    try {
      if (response.data && response.data.encrypted) {
        response.data = decryptData(response.data);
      }
    } catch (error) {
      console.error("Response decryption error:", error);
    }
    return response;
  },
  (error) => {
    try {
      // Decrypt error response if it's encrypted
      if (
        error.response &&
        error.response.data &&
        error.response.data.encrypted
      ) {
        error.response.data = decryptData(error.response.data);
      }
    } catch (decryptError) {
      console.error("Error response decryption failed:", decryptError);
    }
    return Promise.reject(error); // still reject so catch() runs
  }
);

export default axiosInstance;

// =============================================

// import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,
//   // timeout: 2000,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//   },
// });

// // Add a request interceptor
// axiosInstance.interceptors.request.use(
//   (config) => {
//     try {
//       const token = sessionStorage.getItem("token");
//       if (token) {
//         config.headers["Authorization"] = `Bearer ${token}`;
//       }
//     } catch (error) {
//       console.error("Error retrieving token from sessionStorage:", error);
//     }
//     return config;
//   },
//   (error) => {
//     // Do something with request error
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;
